/**
 * @fileoverview GET handler for the "/engagement/link_alias_campaign_email_click_daily_stats/:campaign_id/:mv_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLinkAliasCampaignEmailClickDailyStats } from "./constants";
import type {
  LinkAliasCampaignEmailClickDailyStatsResult,
  LinkAliasCampaignEmailClickDailyStatsParams,
} from "./types";

export const getLinkAliasCampaignEmailClickDailyStats = reactQueryFetcherAdapter(
  engagementLinkAliasCampaignEmailClickDailyStats,
  (
    signal: AbortSignal,
    { campaignId, mvId, start, end, isAmp }: LinkAliasCampaignEmailClickDailyStatsParams
  ): Promise<LinkAliasCampaignEmailClickDailyStatsResult> => {
    return fetch(
      `/engagement/link_alias_campaign_email_click_daily_stats/${campaignId}/${mvId}`,
      "GET",
      { start, end, is_amp: isAmp },
      { signal }
    );
  }
);
